// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ManufacturerDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ManufacturerApiClient extends BaseCRUDApiClient<ManufacturerDto> {
  baseUrl = this.config.apiEndpoint + '/manufacturer';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
